import * as React from 'react';

import {Enum} from 'shells/entity/entity-display-values/enum';

import styles from './cell.module.css';

type Props = {
    value: string | string[] | null | undefined;
};

export function CellEnum(props: Props) {
    if (!props.value || !props.value.length) {
        return null;
    }

    const displayValue = Array.isArray(props.value) ? props.value.join(', ') : props.value;

    return (
        <div title={displayValue} className={styles['cell-content']}>
            <Enum value={props.value} />
        </div>
    );
}
